import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { cn } from '@/utils/cn';

export interface QuickActionItem {
  to: string;
  label: string;
  description?: string;
}

interface QuickActionGridProps {
  items: QuickActionItem[];
  columns?: 2 | 3 | 4;
  className?: string;
}

const columnClass: Record<number, string> = {
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-2 lg:grid-cols-3',
  4: 'sm:grid-cols-2 lg:grid-cols-4',
};

export function QuickActionGrid({ items, columns = 3, className }: QuickActionGridProps) {
  return (
    <div className={cn('grid gap-3', columnClass[columns], className)}>
      {items.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className="group card flex flex-col p-4 transition-colors duration-fast hover:border-primary-300 dark:hover:border-primary-700"
        >
          <div className="flex items-start justify-between gap-2">
            <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">{item.label}</p>
            <ArrowForwardIcon
              className="h-4 w-4 shrink-0 text-slate-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-600 dark:group-hover:text-primary-400"
              fontSize="inherit"
            />
          </div>
        </Link>
      ))}
    </div>
  );
}
